import React from 'react'
import { Avatar, Container, Grid, Paper, Typography, Box, Link } from '@mui/material'
import { GitHub, School, AccountBox, YouTube } from '@mui/icons-material'
import Title from '../title/Title'

export default function About() {
  return (
    <Container maxWidth="xl">
      <Title title="Hakkımızda" />
      <Box sx={{ 
        flexGrow: 1, 
        p: { xs: 2, sm: 3, md: 4 },
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Paper elevation={3} sx={{ width: '100%', maxWidth: 800, mx: 'auto', p: 4 }}>
          <Grid container spacing={4}>
            {/* Profile Section */}
            <Grid item xs={12} sx={{ textAlign: 'center' }}>
              <Avatar
                src="https://profil.samsun.edu.tr/images/employees/zafer.comert.png"
                alt="Dr. Zafer CÖMERT"
                sx={{
                  width: 200,
                  height: 200,
                  mx: 'auto',
                  mb: 3,
                  border: '3px solid #3498db'
                }}
              />
              <Typography variant="h4" gutterBottom>Dr. Zafer CÖMERT</Typography>
              <Typography variant="h5" color="primary" gutterBottom>Öğretim Üyesi</Typography>
              <Typography variant="subtitle1" color="text.secondary" paragraph>
                Samsun Üniversitesi Mühendislik Fakültesi Yazılım Mühendisliği Bölümü
              </Typography>
            </Grid>

            {/* Research Interests */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ borderBottom: 2, borderColor: 'primary.main', pb: 1, mb: 2 }}>
                Araştırma Alanları
              </Typography>
              <Box component="ul" sx={{ listStyle: 'none', pl: 2 }}>
                {['Bilgisayar Görüsü', 'İşaret İşleme', 'Yapay Zekâ', 'Makine Öğrenmesi', 'Derin Öğrenme']
                  .map((item, index) => (
                    <Box component="li" key={index} sx={{ 
                      mb: 1,
                      display: 'flex',
                      alignItems: 'center',
                      '&:before': {
                        content: '"•"',
                        color: 'primary.main',
                        pr: 1
                      }
                    }}>
                      <Typography>{item}</Typography>
                    </Box>
                  ))}
              </Box>
            </Grid>

            {/* Experience */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ borderBottom: 2, borderColor: 'primary.main', pb: 1, mb: 2 }}>
                Deneyim ve Faaliyetler
              </Typography>
              <Box component="ul" sx={{ listStyle: 'none', pl: 2 }}>
                {[
                  'Ulusal ve uluslararası projelerde yürütücü, araştırmacı ve eğitmen',
                  'Lisans ve lisansüstü seviyede akademik eğitmenlik',
                  'Bilgi İşlem Daire Başkanlığı ve Teknik Danışmanlık',
                  'Teknoloji şirketi kurucusu'
                ].map((item, index) => (
                  <Box component="li" key={index} sx={{ 
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    '&:before': {
                      content: '"•"',
                      color: 'primary.main',
                      pr: 1
                    }
                  }}>
                    <Typography>{item}</Typography>
                  </Box>
                ))}
              </Box>
            </Grid>

            {/* Profile Links */}
            <Grid item xs={12} sx={{ textAlign: 'center' }}>
              <Typography variant="h6" sx={{ mb: 2 }}>Profil Bağlantıları</Typography>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                {[
                  { 
                    title: 'Google Akademik', 
                    url: 'https://scholar.google.com.tr/citations?user=jn5XC4YAAAAJ&hl=tr',
                    icon: <School />
                  },
                  { 
                    title: 'GitHub', 
                    url: 'https://github.com/zcomert',
                    icon: <GitHub />
                  },
                  { 
                    title: 'Üniversite Profili', 
                    url: 'https://profil.samsun.edu.tr/Academic/About/zcomert',
                    icon: <AccountBox />
                  },
                  { 
                    title: 'YouTube', 
                    url: 'https://www.youtube.com/@virtual.campus',
                    icon: <YouTube />
                  }
                ].map((link, index) => (
                  <Link
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: 'primary.main',
                      border: 1,
                      borderColor: 'primary.main',
                      borderRadius: 1,
                      px: 2,
                      py: 1,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      textDecoration: 'none',
                      '&:hover': {
                        bgcolor: 'primary.main',
                        color: 'white'
                      }
                    }}
                  >
                    {link.icon}
                    {link.title}
                  </Link>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Container>
  )
}
